import { Dayjs } from "dayjs";

export default interface TrabalhoTipo {
    codigo: number;
    nome: string;
    descricao: string | null;
    dataCriacao: Date | Dayjs;
}

export enum EnumTrabalhoTipo {
    AuttarCBA = 1,
    ConciliacaoGetNet = 3,
    GetNetLiquida = 6,
    PagBankConciliacao = 8, // Vendas
    PagBankConciliacaoPagamentos = 9,
    PagBankConciliacaoCancelamentos = 10,
    ConciliacaoGetNetExtratoEletronico = 11
}